import * as styles from './Mask.module.css'

function Mask(props) {
  const { className = styles.Mask } = props

  return <div {...props} className={className} />
}

export { Mask }
